export const SELL_TICKET_FORM = 'sellTicketForm';
export const BANK_ACCOUNT_FORM = 'bankAccountForm';

export const TICKET_CODES_FORM = 'ticketCodesForm';

export const BANK_ACCOUNT_NAME_FIELD = 'accountName';
export const BANK_ACCOUNT_IBAN_FIELD = 'iban';
export const BANK_ACCOUNT_BIC_FIELD = 'bic';
export const BANK_ACCOUNT_FUTURE_USE_FIELD = 'futureUse';

export const BANK_ACCOUNT_INITIAL_STATE = {
    [BANK_ACCOUNT_NAME_FIELD]: {
        value: null,
        isValid: true,
        errorMessage: null,
    },
    [BANK_ACCOUNT_IBAN_FIELD]: {
        value: null,
        isValid: true,
        errorMessage: null,
    },
    [BANK_ACCOUNT_BIC_FIELD]: {
        value: null,
        isValid: true,
        errorMessage: null,
        isVisible: false,
    },
    [BANK_ACCOUNT_FUTURE_USE_FIELD]: {
        value: true,
        isValid: true,
        errorMessage: null,
    },
};
export const SALE_OPTIONS_FORM = 'saleOptionsForm';
export const SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD = 'allowTypeSale';
export const SALE_OPTIONS_SEAT_TOGETHER_FIELD = 'seatTogether';
export const SALE_OPTIONS_TERMS_FIELD = 'terms';

export const SALE_OPTIONS_INITIAL_STATE = {
    [SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
        isVisible: true,
    },
    [SALE_OPTIONS_SEAT_TOGETHER_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
        isVisible: true,
    },
    [SALE_OPTIONS_TERMS_FIELD]: {
        value: false,
        isValid: true,
        errorMessage: null,
    },
};
